/* unplugin-vue-components disabled */import script from "./tab-block.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-block.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__